export default __webpack_public_path__ + "static/media/team59.6ab5c1c7.JPG";